import { useNavigate } from 'react-router-dom';
import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function TicketSoldOut({ onClose }: ModalProps) {
  const navigate = useNavigate();
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>입장권 예매 마감</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>
            현재 사전 예약은 마감되었습니다. <br /> 현장에서도 선착순으로 입장이
            가능하오니 <br />
            많은 관심과 참여 부탁드립니다.
          </S.Summary>
          <S.Summary>이용에 불편을 드려 진심으로 죄송합니다. </S.Summary>
        </S.ModalContent>
        <S.CloseButton
          type="button"
          onClick={() => {
            onClose();
            navigate('/');
          }}
        >
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
